export const MOUSE_EVENT_BUTTONS = {
  left: 0,
  middle: 1,
  right: 2,
};
